const Colors = {
  primary: "#9a0606",
  secondary: "#2b638f",
  background: "#F5F5F5",
  error: "#FF3333",
  success: "#4CAF50",
  blue: "#0000FF",
  warning: "#FFC107",
  textPrimary: "#000000",
  textSecondary: "white",
  border: "#E0E0E0",
};

const Typography = {
  fontSizes: {
    small: 12,
    medium: 16,
    large: 24,
    xLarge: 32,
    xlLarge: 46,
  },
  fontWeights: {
    regular: "400",
    medium: "600",
    bold: "700",
    extraBold: "800",
  },
  fontFamily: {
    regular: "System",
    bold: "System-Bold",
  },
};

const Spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
};

const Shadows = {
  light: {
    shadowColor: Colors.textSecondary,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  medium: {
    shadowColor: Colors.textSecondary,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 6,
    elevation: 4,
  },
  heavy: {
    shadowColor: Colors.textSecondary,
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 6,
  },
};

const theme = {
  Colors,
  Typography,
  Spacing,
  Shadows,
};

export default theme;
